import { Component, OnInit, EventEmitter, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';

@Component({
  selector: 'app-yes-no-confirmation',
  templateUrl: './yes-no-confirmation.component.html',
  styleUrls: ['./yes-no-confirmation.component.scss']
})
export class YesNoConfirmationComponent implements OnInit {

  @Input() title: any

  public event: EventEmitter<any> = new EventEmitter();

  constructor(public bsModalRef: BsModalRef) { }

  ngOnInit() {
  }

  confirm() {
    this.bsModalRef.hide()
    this.triggerEvent(true)
  }

  decline() {
    this.triggerEvent(false)
    this.bsModalRef.hide()
  }
  
  triggerEvent(item) {
    this.event.emit({ data: item, res: 200 });
  }

  
}
